import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './store';
import App from './components/App';
import i18next from './locales/i18n';
import * as serviceWorker from './serviceWorker';
import './index.css';
import './styles/toaser.min.css';

const semanticCss = document.getElementById('semantic').getAttribute("href");
const semanticRtlCss = document.getElementById('semantic.rtl').getAttribute("href");

let currentLangDirection;
store.subscribe(() => {
    let previousLangDirection = currentLangDirection;
    currentLangDirection = i18next.dir();

    if (previousLangDirection !== currentLangDirection) {
        if (i18next.dir() === 'rtl') {
            document.getElementById('semantic').setAttribute("href", "");
            document.getElementById('semantic.rtl').setAttribute("href", semanticRtlCss);
        } else {
            document.getElementById('semantic').setAttribute("href", semanticCss);
            document.getElementById('semantic.rtl').setAttribute("href", "");
        }
        localStorage.setItem('language', i18next.language);
    }
});

document.body.setAttribute('dir', i18next.dir());

ReactDOM.render(<Provider store={store}><App /></Provider>, document.getElementById('root'));
serviceWorker.register({
    skipWaiting: true,
    onUpdate: () => {
        // toastr.confirm('New content is available.', {
        //     okText: 'Refresh',
        //     onOk: () => {
        //         window.location.reload(true);
        //     },
        //     disableCancel: true
        // });
    }
});